/* eslint-disable camelcase */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiClient from 'src/api/api-client';
import { getCVURI, updateCVStatusURI } from '../api';
import { setValue } from './MessageSlice';
// First, create the thunk
export const fetchCV = createAsyncThunk(
  'cv/fetchCV',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'get',
          url: `${getCVURI}`,
          params,
        })
        .then(res => res.data);
      return response.data;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);
export const updateCVStatus = createAsyncThunk(
  'cv/updateCVStatus',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      await apiClient
        .handleRequest({
          method: 'post',
          url: `${updateCVStatusURI(data.id)}`,
          data,
        })
        .then(res => res.data);
      return data.status;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

// Then, handle actions in your reducers:
const cvSlice = createSlice({
  name: 'cv',
  initialState: {
    entities: [],
    loading: 'idle',
    saving: 'idle',
    saving_id: 0,
    currentRequestId: undefined,
    error: null,
    currentPage: 1,
    totalPage: 1,
    total: 0,
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: {
    [fetchCV.pending]: (state, action) => {
      if (state.loading === 'idle') {
        state.loading = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchCV.fulfilled]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        const { data, last_page, current_page, total } = action.payload;
        state.loading = 'idle';
        state.entities = data;
        state.currentPage = current_page;
        state.totalPage = last_page;
        state.currentRequestId = undefined;
        state.total = total;
      }
    },
    [fetchCV.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },

    [updateCVStatus.pending]: (state, action) => {
      if (state.saving === 'idle') {
        state.saving = 'pending';
        state.saving_id = action.meta.arg.id;
        state.currentRequestId = action.meta.requestId;
      }
    },
    [updateCVStatus.fulfilled]: (state, action) => {
      state.saving = 'idle';
      const { id, status } = action.meta.arg;
      const idx = state.entities?.findIndex(i => i.id === id);
      if (idx !== -1) {
        state.entities[idx].status = status;
      }
    },
    [updateCVStatus.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.saving === 'pending' && state.currentRequestId === requestId) {
        state.saving = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
  },
});

export default cvSlice.reducer;
